import { render, staticRenderFns } from "./DialogCreateBot.vue?vue&type=template&id=2a38a975&scoped=true"
import script from "./DialogCreateBot.vue?vue&type=script&lang=js"
export * from "./DialogCreateBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a38a975",
  null
  
)

export default component.exports